import axios from 'axios';

import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';

import addPayloadCasingInterceptors from 'core/axios/interceptors/addPayloadCasingInterceptors';
import addURLSlashesInterceptors from 'core/axios/interceptors/addURLSlashesInterceptors';
import RequestMethod from 'core/axios/RequestMethod';

// Create custom client here instead of using client from core/axios/index.js
// for our third party APIs
const client = axios.create();
addPayloadCasingInterceptors(client);
addURLSlashesInterceptors(client);

/* Unsplash API */
export const searchPhotos = ({ params, clientId }) =>
  client
    .request({
      url: `https://api.unsplash.com/search/photos/`,
      method: RequestMethod.GET,
      params,
      headers: {
        'Accept-Version': 'v1',
        Authorization: `Client-ID ${clientId}`,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getPhotos = ({ params, clientId }) =>
  client
    .request({
      url: `https://api.unsplash.com/photos/`,
      method: RequestMethod.GET,
      params,
      headers: {
        'Accept-Version': 'v1',
        Authorization: `Client-ID ${clientId}`,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const downloadPhoto = ({ clientId, downloadLocation }) =>
  client
    .request({
      url: `${downloadLocation}`,
      method: RequestMethod.GET,
      headers: {
        'Accept-Version': 'v1',
        Authorization: `Client-ID ${clientId}`,
      },
    })
    .then(handleJSONResponse)
    .catch(handleError);
